import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MedicineReminderService } from '../../services/medicine-reminder.service';
import { DownloadSectionComponent } from '../../components/download-section/download-section.component';

@Component({
  selector: 'app-medicine-reminder',
  templateUrl: './medicine-reminder.component.html',
  styleUrls: ['./medicine-reminder.component.css'],
  standalone: true,
  imports: [CommonModule, DownloadSectionComponent]
})
export class MedicineReminderComponent implements OnInit {
  medicineReminderContent: any;

  constructor(private medicineReminderService: MedicineReminderService) { }

  ngOnInit(): void {
    this.medicineReminderService.getMedicineReminderContent().subscribe(data => {
      this.medicineReminderContent = data[0];
    });
  }
}
